import { logger } from './dccLogger'

const STORAGE_KEY = 'dcc_session_id'
const MAX_RECOVERY_ATTEMPTS = 2

let currentSessionId: string | null = null
let recoveryAttempts = 0

export const sessionIdManager = {
    set(id: string): void {
        currentSessionId = id
        recoveryAttempts = 0
        try {
            sessionStorage.setItem(STORAGE_KEY, id)
        } catch (error) {
            logger.warn(`Failed to persist session ID to sessionStorage: ${error}`)
        }
    },

    get(): string | null {
        if (currentSessionId) {
            return currentSessionId
        }

        try {
            const stored = sessionStorage.getItem(STORAGE_KEY)
            if (stored) {
                currentSessionId = stored
                return stored
            }
        } catch {
            // no session id stored yet
        }

        return null
    },

    clear(): void {
        currentSessionId = null
        try {
            sessionStorage.removeItem(STORAGE_KEY)
        } catch {
            // sessionStorage may be unavailable
        }
    },

    recordRecoveryAttempt(): boolean {
        recoveryAttempts += 1
        const allowed = recoveryAttempts <= MAX_RECOVERY_ATTEMPTS

        logger.info(
            `Session recovery attempt ${recoveryAttempts}/${MAX_RECOVERY_ATTEMPTS} – ${allowed ? 'retrying' : 'budget exhausted'}`,
        )
        return allowed
    },

    resetRecoveryAttempts(): void {
        recoveryAttempts = 0
    },
}
